import { render, staticRenderFns } from "./CtrlShiiresaki.vue?vue&type=template&id=3dc3b12d&"
import script from "./CtrlShiiresaki.vue?vue&type=script&lang=ts&"
export * from "./CtrlShiiresaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports